import React from 'react';

const AuthErrorFallback: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-600 via-black to-red-900 flex items-center justify-center p-4">
      <div className="text-center text-white">
        <h2>Authentication Error</h2>
        <p>Please refresh the page to try again.</p>
        <button 
          onClick={() => window.location.reload()} 
          className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default AuthErrorFallback;